<template>
    <div id="app">
        <!-- 全局导航栏 -->
        <nav>
            <router-link to="/" title="首页">首页</router-link>
            <router-link to="/user" title="个人中心">个人中心</router-link>
            <router-link to="/about" title="关于">关于</router-link>
        </nav>

        <!-- 侧边栏或其他全局元素可以放在这里 -->
        <!-- 根据用户状态显示登录或用户信息 -->
        <div v-if="!isLoggedIn">
            <button @click="login">登录</button>
            <button @click="register">注册</button>
        </div>
        <div v-else>
            <span>{{ userName }}</span>
            <button @click="logout">退出</button>
        </div>

        <!-- 这里是路由视图，会根据当前路由渲染对应的组件 -->
        <router-view />

        <!-- 页脚 -->
        <footer>
            <p>版权信息 &copy; 2025 网站开发学习测试 | <a href="http://beian.miit.gov.cn/" target="_blank">蜀ICP备2025131719号</a></p>
            <p><a href="https://beian.mps.gov.cn/#/query/webSearch?code=51011202001084" rel="noreferrer" target="_blank"><img class="logos" src="./assets/gonganbeian.png" width="20"> 川公网安备51011202001084号</a></p>
        </footer>
    </div>
</template>

<script>
    import { mapState } from 'vuex'; // 使用 Vuex 管理登录状态和用户信息
    
    export default {
        name: 'App',
        // 在这里可以定义一些全局的数据和方法，如果需要的话
        computed: {
            ...mapState(['isLoggedIn', 'userName']), // 在 Vuex 中管理登录状态和用户名
        },
        methods: {
            login() {
                // 在重定向到登录页之前，保存用户原来的路由位置(排除login和register本身的路由)
                if(this.$route.fullPath !== '/login' && this.$route.fullPath !== '/register'){
                    sessionStorage.setItem('redirectRoute', this.$route.fullPath);
                }
                // 跳转到登录
                this.$router.push('/login');
            },
            register() {
                // 跳转到注册
                this.$router.push('/register');
            },
            logout() {
                // 调用 Vuex 中的 logout 方法来处理登出逻辑
                // Vuex 中有方法来重置登录状态和用户名
                this.$store.dispatch('logout');
            }
        },
        created() {
            // 检查 token 是否存在并且是否过期
            const token = localStorage.getItem('token');
            const tokenExpiration = localStorage.getItem('tokenExpiration');
            const now = Date.now();

            if (token && tokenExpiration && now < Number(tokenExpiration)) {
                // 如果 token 存在并且没有过期，更新 Vuex 的登录状态
                console.log('刷新页面启动应用时没有过期');
                this.$store.commit('setLoggedIn', { isLoggedIn: true, userName: localStorage.getItem('userName') });
            } else {
                // 如果 token 不存在或者已经过期，清除 token 和过期时间
                console.log('刷新页面启动应用时过期了哦哦哦');
                localStorage.removeItem('token');
                localStorage.removeItem('tokenExpiration');
                localStorage.removeItem('userName');

                // 更新 Vuex 的登录状态
                this.$store.commit('setLoggedIn', { isLoggedIn: false, userName: '' });
            }
        }
    }
</script>

<style>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }

    /* 其他全局样式可以放在这里 */
    nav {
        padding-bottom: 20px;
    }

    nav a {
        margin: 0px 10px;
    }

    footer {
        border-top: 1px solid #e2e2e2;
        margin-top: 50px;
    }
</style>